<template>
  <!-- 上传大文件测试 -->
  <div class="upload-audio">
    <div class="upload-list">
      <el-upload class="upload-demo"
                 action
                 name="hahode"
                 :on-success="uploadSuccess"
                 :before-upload="uploadBefore"
                 :on-exceed="uploadExceed"
                 :on-progress="uploadProgress"
                 :on-error="uploadError"
                 accept=".mp3"
                 :limit="max_file_num"
                 list-type="text"
                 :http-request="uploadAudio"
                 :show-file-list="false"
                 multiple
                 :data="{hello:'world'}">
        <div class="click">
          <el-button size="small"
                     type="primary"
                     class="iblock vm">点击上传</el-button>
          <span>支持mp3，为保证音频加载与播放的流畅性，建议上传大小不超过500M</span>
        </div>
      </el-upload>
    </div>
    <div class="audio-list">
      <ul v-if="file_list.length>0">
        <li v-for="(item,index) in file_list"
            :key="index">
          <span class="w300 vm iblock text-ellipsis"
                style="width:300px;">{{item.name}}</span>
          <span class="ml20"
                v-if="(item.progress===100)||item.progress===200">
            <i class="el-icon-delete blue cp"
               @click="delectAudio(index)"></i>
          </span>
          <el-progress v-if="(item.progress<100)"
                       class="w300"
                       :percentage="item.progress"
                       :color="item.progress===100?'#67c23a':'#409eff'"
                       :format="format"></el-progress>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import upload from "@/base/js/upload.js";

const MAX_FILE_SIZE_LIMIT = 8,
  MAX_FILE_NUM = 5;
export default {
  data () {
    return {
      max_file_num: MAX_FILE_NUM,
      audio: [],
      file_list: []
    };
  },
  props: {
    linkAudio: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  watch: {
    linkAudio (val, oldVal) {
      // 只有首次加载时才赋值，否则会导致fileList重复赋值问题
      if (oldVal.length == 0) {
        // str.substr(str.indexOf('-') + 1)
        let data = val.map(item => {
          return {
            name: item.substr(item.indexOf("-") + 1),
            link: item,
            progress: 200,
            uid: ""
          };
        });
        this.file_list = data;
      }
    }
  },
  methods: {
    // 进度条
    format (percentage) {
      return percentage === 100 ? "成功" : `${percentage}%`;
    },
    //测试上传方法
    uploadAudio (content) {
      let data = {
        uid: content.file.uid,
        name: content.file.name,
        progress: 0,
        link: ""
      };
      this.file_list.push(data);
      return new upload({
        onProgress: content.onProgress,
        onSuccess: content.onSuccess,
        onError: content.onError
      }).upload(content.file);
    },
    //删除文件
    delectAudio (index) {
      this.file_list.splice(index, 1);
      this.$emit("updateAudioList", this.getAudioList(this.file_list));
    },
    //上传文件超出个数限制时的钩子
    uploadExceed (files, fileList) {
      // console.log(files,fileList);
      // this.$message.warning(
      //   `当前限制选择 ${this.max_file_num} 个文件，本次选择了 ${
      //     files.length
      //   } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      // );
    },
    //上传前的钩子
    uploadBefore (file) {
      if (!(file.type.indexOf("audio") > -1)) {
        this.$message.error("请选择正确的音频文件");
      }
    },
    //上传成功后的钩子
    uploadSuccess (response, file) {
      this.file_list.forEach((item, i) => {
        if (item.uid == file.uid) {
          item.link = response.result.link;
        }
      });
      if (this.file_list.length > 0) {
        // console.log(this.getAudioList(this.file_list));
        this.$emit("updateAudioList", this.getAudioList(this.file_list));
      }
    },
    //上传失败的文件处理
    uploadError (file) {
      // console.log(file);
      this.$message.error(`音频文件：（${file.name}）上传失败`);
      this.file_list.forEach((item, i) => {
        if (item.uid == file.uid) {
          this.file_list.splice(i, 1);
        }
      });
      this.$emit("updateAudioList", this.getAudioList(this.file_list));
    },
    //一个获取链接的方法
    getAudioList (data) {
      return data.map(item => {
        return item.link;
      });
    },
    uploadProgress (data) {
      this.file_list.forEach((item, i) => {
        if (item.uid == data.file.uid) {
          item.progress = data.progress;
        }
      });
    },
  }
};
</script>


<style lang="less" scoped>
.upload-audio {
  overflow: hidden;
  .upload-list {
    width: 500px;
    overflow: hidden;
    .click {
      span {
        display: inline-block;
        margin-left: 10px;
        width: 225px;
        font-size: 12px;
        line-height: 16px;
        color: #999999;
        vertical-align: middle;
      }
    }
  }
}
</style>